<script>
import dayjs from '../core/dayjs';
import { VBTooltip, BDropdown, BDropdownText, BDropdownItem, BDropdownHeader, BDropdownItemButton } from 'bootstrap-vue';

const EXPORT_NOTIFICATIONS = [
  "Bulldesk\\Export\\Notification\\ExportNotification",
  "Bulldesk\\Export\\Notification\\ProgressExportNotification",
  "Bulldesk\\User\\Notification\\LeadExportNotification",
];

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  components: {
    BDropdown,
    BDropdownText,
    BDropdownItem,
    BDropdownHeader,
    BDropdownItemButton,
  },

  props: ['user'],

  data () {
    return {
      notifications: [],
      loading: true,
    };
  },

  computed: {
    unread () {
      let unread = 0;
      for (let i = 0; i < this.notifications.length; i++) {
        const notification = this.notifications[i];

        if (! notification.read_at) {
          unread++;
        }
      }

      return unread;
    },
  },

  created () {
    this.getBadges();
    this.getNotifications();

    const me = this;

    Echo.private(`Bulldesk.User.Model.User.${this.user.id}`)
      .notification((notification) => {
        me.addNotification(notification);
      })
      .listen('.tenant_changed', (event) => {
        console.log(event);
      });
  },

  methods: {
    readNotifications () {
      this.$http.get('/notification/read/notifications').then(response => {
        this.notifications = response.data;
      }).catch(error => {
        console.error("Erro ao marcar notificações como lidas:", error);
      });
    },

    getNotifications (callback) {
      this.$http.get('/notification').then((response) => {
        this.notifications = response.data;

        if (callback) {
          callback();
        }

        this.loading = false;
      });
    },

    getBadges () {
      this.$http.get('/notification/badges').then((response) => {
        const badges = response.data;
        const header = document.querySelector('#header');

        for (let i; i < badges.length; i++) {
          const route = `route${i}`;
          const nav = header.dataset[route];

          if (nav.length && badges[i] > 0) {
            const badge = document.createElement('div');

            badge.classList.add(
              'badge',
              'badge-pill',
              'badge-white',
              'float-lg-right',
            );
            badge.textContent = badges[i];
            nav.prepend(badge);
          }
        }
      })
        .catch((e) => {
          console.error(e);
        });
    },

    getUrl (notification) {
      let url = notification.url || notification.data.url;

      if (! notification.id) {
        return url;
      }

      if(EXPORT_NOTIFICATIONS.includes(notification.type)) {
        return url;
      }

      url = url || window.location.href;

      if (url.indexOf('?')) {
        url = url.replace('?', `?nid=${notification.id}&`);
      } else if (url.indexOf('#')) {
        url = url.replace('#', `?nid=${notification.id}#`);
      }

      return `/notification/read?nid=${notification.id}&to=${url}`;
    },

    addNotification (notification) {
      this.getNotifications();

      const me = this;
      const title = document.title.replace('(1) ', '');

      document.title = `(1) ${title}`;

      const callback = ({ isConfirmed }) => {
        document.title = title;

        if (isConfirmed) {
          window.open(me.getUrl(notification));
        }

        console.log(isConfirmed);
      };

      Alert.message('info', title, 'bottom-end', 'Fechar', 'Visualizar', callback);
    },

    formatDate (date) {
      return dayjs(date).format('LDT');
    },
  },
};
</script>

<template>
  <div
    class="bdk-notification"
  >
    <BDropdown
      no-caret
      :right="true"
      variant="link"
      menu-class="bdk-notification__dropdown"
      toggle-class="text-decoration-none p-0"
    >
      <template
        #button-content
      >
        <a
          href="javascript:;"
          role="button"
          @click="unread > 0 && readNotifications()"
        >
          <svg
            class="icon"
            width="21"
            xmlns="http://www.w3.org/2000/svg"
            height="21"
            viewbox="0 0 21 21"
          >
            <defs>
              <Clippath id="mtjpa">
                <path
                  fill="#fff"
                  d="M8 12V0h13v12zm6.716-3.196a2.902 2.902 0 1 0 0-5.804 2.902 2.902 0 0 0 0 5.804z"
                />
              </Clippath>
            </defs>
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <g>
                        <path
                          fill="#f6f5f8"
                          d="M9.52 18.789c.905 0 1.639-.734 1.639-1.639h1.31a2.95 2.95 0 1 1-5.898 0h1.31c0 .905.734 1.639 1.64 1.639zm7.21-3.605c0 .36-.295.655-.659.655H2.97a.657.657 0 0 1-.658-.655c0-.361.294-.656.656-.656.723 0 1.31-.587 1.31-1.31V9.284a5.243 5.243 0 1 1 10.487 0v3.932a1.31 1.31 0 0 0 1.31 1.311c.36 0 .656.295.656.656zm1.31 0a1.97 1.97 0 0 0-1.966-1.967V9.285A6.554 6.554 0 0 0 9.52 2.73a6.553 6.553 0 0 0-6.554 6.554v3.933A1.968 1.968 0 0 0 1 15.184c0 1.086.882 1.966 1.97 1.966H16.07c1.087 0 1.97-.88 1.97-1.966z"
                        />
                        <path
                          stroke-width=".5"
                          fill="none"
                          stroke="#f6f5f8"
                          stroke-miterlimit="50"
                          d="M9.52 18.789c.905 0 1.639-.734 1.639-1.639h1.31a2.95 2.95 0 1 1-5.898 0h1.31c0 .905.734 1.639 1.64 1.639zm7.21-3.605c0 .36-.295.655-.659.655H2.97a.657.657 0 0 1-.658-.655c0-.361.294-.656.656-.656.723 0 1.31-.587 1.31-1.31V9.284a5.243 5.243 0 1 1 10.487 0v3.932a1.31 1.31 0 0 0 1.31 1.311c.36 0 .656.295.656.656zm1.31 0a1.97 1.97 0 0 0-1.966-1.967V9.285A6.554 6.554 0 0 0 9.52 2.73a6.553 6.553 0 0 0-6.554 6.554v3.933A1.968 1.968 0 0 0 1 15.184c0 1.086.882 1.966 1.97 1.966H16.07c1.087 0 1.97-.88 1.97-1.966z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g v-if="unread">
                  <path
                    stroke-width="6"
                    fill="none"
                    stroke="#761eeb"
                    stroke-linecap="round"
                    stroke-linejoin="bevel"
                    stroke-miterlimit="50"
                    d="M11.814 5.902a2.902 2.902 0 1 1 5.804 0 2.902 2.902 0 0 1-5.804 0z"
                    clip-path="url('#mtjpa')"
                  />
                  <path
                    fill="#f31357"
                    d="M11.814 5.902a2.902 2.902 0 1 1 5.804 0 2.902 2.902 0 0 1-5.804 0z"
                  />
                </g>
              </g>
            </g>
          </svg>
        </a>
      </template>

      <BDropdownHeader>
        <h4
          v-text="__('Notificações')"
          class="bdk-text-center bdk-notification__header"
        />
      </BDropdownHeader>

      <BDropdownItem
        v-if="notifications.length == 0"
      >
        <a
          href="#"
          class="multiselect__option"
        >
          <div
            class="media-body"
          >
            <h6
              class="bdk-notification__message"
            >
              <span
                v-if="! loading"
                class="bdk-notification__zero"
                v-text="__('Nenhuma notificação')"
              />

              <span
                class="bdk-notification__load"
                v-else
              >
                <i
                  class="fa fa-circle-o-notch fa-spin bdk-notification__icon"
                />

                {{ __('Carregando...') }}
              </span>
            </h6>
          </div>
        </a>
      </BDropdownItem>

      <div
        v-else
        class="dropdown-wrapper"
      >
        <BDropdownItemButton
          :key="index"
          v-for="(notification, index) in notifications"
        >
          <a
            class="bdk-no-underline"
            :href="getUrl(notification)"
            target="_blank"
          >
            <div
              class="bdk-flex"
            >
              <div
                class="pr-10px"
              >
                <i
                  v-if="notification.data.icon"
                  class="bdk-notification__icon"
                  :class="notification.data.icon"
                />

                <i
                  v-else
                  class="fa fa-exclamation-triangle bdk-notification__icon"
                />
              </div>

              <div>
                <h6
                  class="bdk-notification__message"
                  v-text="notification.data.message "
                  :class="{ read: notification.read_at }"
                />

                <div
                  class="bdk-notification__time"
                >
                  <span
                    v-b-tooltip.right="formatDate(notification.created_at)"
                  >
                    {{ notification.created_at | ago }}
                  </span>
                </div>
              </div>
            </div>
          </a>
        </BDropdownItemButton>
      </div>
    </BDropdown>
  </div>
</template>

<style lang="scss" scoped>
  .bdk-notification {
    &__time {
      color: #857a98;
      font-size: 13px;
      font-weight: 400;
      letter-spacing: -0.2px;
      line-height: 20px;
      -webkit-text-stroke: thin;
    }

    &__header {
      text-align: center;
      color: #3b334a;
      font-family: 'Montserrat';
      font-size: 18px;
      font-weight: 400;
      letter-spacing: -0.27px;
      line-height: 30px;
      -webkit-text-stroke: thin;
      margin-bottom: 0px;
    }

    &__icon {
      font-size: 26px;
    }

    &__message {
      font-size: 13px;
      font-weight: 400;
      letter-spacing: -0.2px;
      line-height: 20px;
      word-break: break-word;
      white-space: normal;
      -webkit-text-stroke: thin;
    }

    &__zero,
    &__load {
      color: #857a98;
      font-family: 'Montserrat';
      font-size: 13px;
      font-weight: 400;
      letter-spacing: -0.2px;
      line-height: 20px;
      -webkit-text-stroke: thin;
    }
  }
</style>
